module.exports = __webpack_public_path__ + "static/media/diamond.91c5d0fa.png";